if (!customElements.get('link-list')) {
	class LinkList extends HTMLElement {
		constructor() {
			super()
			this.header = this.querySelector('.header-megamenu__link-list__title')
		}

		connectedCallback() {
			this.header?.addEventListener('click', () => {
				if (this.hasAttribute('open')) {
					this.removeAttribute('open')
				} else {
					this.setAttribute('open', true)
				}
			})
		}
	}
	customElements.define('link-list', LinkList)
}
